import { render, staticRenderFns } from "./ProjectwiseRoiDetail.vue?vue&type=template&id=69c1c95e&"
import script from "./ProjectwiseRoiDetail.vue?vue&type=script&lang=js&"
export * from "./ProjectwiseRoiDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports